import { render, staticRenderFns } from "./WorryAboutRisks.vue?vue&type=template&id=422be33c&"
import script from "./WorryAboutRisks.vue?vue&type=script&lang=js&"
export * from "./WorryAboutRisks.vue?vue&type=script&lang=js&"
import style0 from "./WorryAboutRisks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports